.dashboard {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

@media (min-width: 720px) {
  .dashboard {
    gap: 28px;
  }
}

/* One column on a phone, two on a desktop, as the blueprint's Dashboard. */
.columns {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 16px;
  align-items: start;
}

@media (min-width: 720px) {
  .columns {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
